import { RouteObject } from "react-router"
import CentralConfiguracoes from "."
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../config/data.types"
import { ManageAccounts, MenuOpen } from "@mui/icons-material"

export enum PathRotaCentralConfig {
    configuracoes = "/configuracoes"
}

const routerConfig: RouteObject = {
    path: PathRotaCentralConfig.configuracoes,
    element: <CentralConfiguracoes/>,
}


export const navigationToConfigView = ()=> rotas.navigate(PathRotaCentralConfig.configuracoes)

export function startRouterCentralConfig(){
    const menu:MainMenu = {
        text:"Configurações",
        icon:<ManageAccounts />,
        eventOnClick:navigationToConfigView
    }
    menuRotas.push(menu);
    return routerConfig
}